import type { components } from "@/api-schema";
import { cn } from "@/common/helpers/utils";
import { EmptyValue } from "@/components/ui/empty-value";
import { AddressLines } from "./address-lines";

type Branch = components["schemas"]["Branch"];
type Address = components["schemas"]["Address"];

interface BranchWithAddressProps {
  branch?: Branch | null;
  address?: Address | null;
  className?: string;
}

/**
 * Shared "branch label + address" cell: the branch name in bold on top with the
 * branch address rendered below via {@link AddressLines}. Falls back to a placeholder
 * when no branch is available.
 */
export function BranchWithAddress({ branch, address, className }: BranchWithAddressProps) {
  if (!branch) {
    return (
      <div className={cn("text-left", className)}>
        <EmptyValue />
      </div>
    );
  }

  return (
    <div className={cn("flex flex-col gap-1 text-left", className)}>
      <div className="text-sm font-bold">{branch.name}</div>
      <AddressLines address={address} className="text-muted-foreground text-xs" fallback={null} />
    </div>
  );
}
